import * as React from 'react';

import close from '../images/close.png';

import * as style from './ModalWithChildren.module.css';

const ModalWithChildren = ({ onClose, children }) => {
  return (
    <div className={style.modalBackground}>
      <div className={style.modalDialog}>
        <div className={style.modalCloseButton}>
          <img
            src={close}
            alt=""
            onClick={() => onClose()}
            role="presentation"
          />
        </div>
        {children}
      </div>
    </div>
  );
};

export default ModalWithChildren;
